import dayjs from 'dayjs';
import { jwtDecode } from 'jwt-decode';

export function isTokenExpired(token: string) {
  if (token) {
    const { exp } = jwtDecode(token);
    const expiresAt = dayjs.unix(exp as number);
    const nowMinusTenSeconds = dayjs().subtract(10, 'seconds');

    return expiresAt.isBefore(nowMinusTenSeconds);
  }
  return true;
}

export function returnUser(token: string) {
  const decodedToken = jwtDecode(token);
  return decodedToken as Record<string, string>;
}
